import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pic');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pic',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pic/view.scss */
/* src/app/page.pic/view.scss: no such file or directory */`],
})
export class PagePicComponent implements OnInit, DoCheck {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        this.session_id = WizRoute.segment.session_id;
        await this.service.render();
    }
}

export default PagePicComponent;